import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useStripe,
  useElements,
  CardNumberElement
} from '@stripe/react-stripe-js';

import {
  Form,
  Divider,
  Space,
  Button
} from '@lockerpm/design';

import paymentFormComponents from "../payment-form";

import global from "../../config/global";
import paymentServices from "../../services/payment";

const UpgradePayment = (props) => {
  const {
    PaymentMethods,
    BillingContact,
    BillingAddress
  } = paymentFormComponents;

  const stripe = useStripe();
  const elements = useElements();

  const {
    className = '',
    isCancel = true,
    result = {},
    onAdded = () => {},
    onCancel = () => {}
  } = props
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [callingAPI, setCallingAPI] = useState(false);

  const handleSave = async (values) => {
    setCallingAPI(true);
    const cardNumberElement = elements.getElement(CardNumberElement);
    const tokenData = {
      name: values.name,
      address_line1: values.address,
      address_line2: values.address_country,
      address_country: values.address_country,
      country: values.address_country,
      address_city: values.address_city,
      address_state: values.address_state || '',
      address_zip: values.address_zip || '',
      currency: result.currency
    }
    await stripe.createToken(cardNumberElement, tokenData).then(async (response) => {
      if (response.error) {
        switch (response.error?.type) {
          case 'validation_error':
            global.pushError({ message: t('notification.error.payment.validation_error') });
            break
          default:
            global.pushError({ message: t('notification.error.payment.generic_decline') });
        }
      } else {
        await paymentServices.add_payments_card({
          token_card: response.token.id,
          metadata: {
            email: values.contact_email,
            contact_name: values.contact_name,
            company: values.contact_company
          }
        }).then((response) => {
          global.pushSuccess(t('notification.success.payments.added_card'));
          onAdded(response);
        }).catch((error) => {
          global.pushError(error)
        })
      }
    })
    setCallingAPI(false);
  };

  return (
    <div className={`upgrade-payment ${className}`}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave}
      >
        <PaymentMethods/>
        <Divider />
        <BillingContact/>
        <Divider />
        <BillingAddress/>
        <Divider />
        <Space size={[12, 12]} className="flex items-center justify-end">
          {
            isCancel && <Button
              onClick={onCancel}
            >
              {t('button.cancel')}
            </Button>
          }
          <Button
            className="w-[150px]"
            type="primary"
            htmlType="submit"
            disabled={callingAPI}
          >
            {t('button.save')}
          </Button>
        </Space>
      </Form>
    </div>
  );
}

export default UpgradePayment;